import React, { useEffect } from "react";
import {
  Avatar,
  TextField,
  Button,
  Grid,
  IconButton,
  FormControl,
  InputLabel,
  Select,
} from "@mui/material";
import { PhotoCamera } from "@mui/icons-material";
import { styled } from "@mui/material/styles";
import { blueGrey, lightBlue } from "@mui/material/colors";
import { useStyle } from "./styles";
import Provider from "./Provider";
import { useLocation } from "react-router-dom";

/// For Button Submit And Reset Button -------------->
const ColorButton = styled(Button)(({ theme }) => ({
  color: theme.palette.getContrastText(lightBlue[600]),
  backgroundColor: lightBlue[500],
  fontFamily: "Poppins, sans-serif",
  "&:hover": {
    backgroundColor: lightBlue[600],
  },
}));

function AdminEdit() {
  const classes = useStyle();
  const loc = useLocation().state;

  const {
    errors,
    fullName,
    setFullname,
    emailAddress,
    setEmailAddress,
    mobile_number,
    setMobile_Number,
    password,
    setPassword,
    accountStatus,
    profileStatus,
    preview,
    userName,
    setUserName,
    fillAcconutStatus,
    fillProfileStatus,
    handleAccount,
    handleProfile,
    handleImage,
    handleSubmit,
    handleReset,
  } = Provider();

  return (
    <div className={classes.mainContainer}>
      <div className={classes.box}>
        <div className={classes.heading}>Add {loc?.role}</div>
        <div className={classes.rowStyle}>
          <Avatar alt="Photo" src={preview} sx={{ width: 100, height: 100 }} />
          <IconButton
            color="primary"
            aria-label="upload picture"
            component="label"
            fullWidth
          >
            <input hidden accept="image/*" type="file" onChange={handleImage} />
            <PhotoCamera />
          </IconButton>
        </div>

        <Grid container spacing={1} style={{ marginTop: 5 }}>
          <Grid item xs={6}>
            <TextField
              fullWidth
              onChange={(event) => setFullname(event.target.value)}
              label="Full Name"
              value={fullName}
              variant="outlined"
              InputProps={{
                style: { fontFamily: "Poppins, sans-serif" },
              }}
              InputLabelProps={{
                style: { fontFamily: "Poppins, sans-serif" },
              }}
              required
              error={!!errors.fullName}
              helperText={errors.fullName}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              fullWidth
              onChange={(event) => setEmailAddress(event.target.value)}
              label="Email Address"
              value={emailAddress}
              variant="outlined"
              InputProps={{
                style: { fontFamily: "Poppins, sans-serif" },
              }}
              InputLabelProps={{
                style: { fontFamily: "Poppins, sans-serif" },
              }}
              required
              error={!!errors.emailAddress}
              helperText={errors.emailAddress}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              fullWidth
              onChange={(event) => setUserName(event.target.value)}
              label="User Name"
              value={userName}
              variant="outlined"
              InputProps={{
                style: { fontFamily: "Poppins, sans-serif" },
              }}
              InputLabelProps={{
                style: { fontFamily: "Poppins, sans-serif" },
              }}
              required
              error={!!errors.userName}
              helperText={errors.userName}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              fullWidth
              onChange={(event) => setPassword(event.target.value)}
              label="Password"
              value={password}
              variant="outlined"
              type="password"
              InputProps={{
                style: { fontFamily: "Poppins, sans-serif" },
              }}
              InputLabelProps={{
                style: { fontFamily: "Poppins, sans-serif" },
              }}
              required
              error={!!errors.password}
              helperText={errors.password}
            />
          </Grid>

          <Grid item xs={6}>
            <TextField
              fullWidth
              onChange={(event) => setMobile_Number(event.target.value)}
              label="Mobile No"
              variant="outlined"
              type="number"
              value={mobile_number}
              inputProps={{ maxLength: 10 }}
              InputProps={{
                style: { fontFamily: "Poppins, sans-serif" },
              }}
              InputLabelProps={{
                style: { fontFamily: "Poppins, sans-serif" },
              }}
              required
              error={!!errors.mobile_number}
              helperText={errors.mobile_number}
            />
          </Grid>

          <Grid item xs={6}>
            <FormControl fullWidth>
              <InputLabel
                id="demo-simple-select-label"
                sx={{ fontFamily: "Poppins" }}
              >
                Account Status
              </InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={accountStatus}
                label="Account Status"
                onChange={handleAccount}
                sx={{ fontFamily: "Poppins" }}
                required
                error={!!errors?.accountStatus}
                helperText={errors?.accountStatus}
              >
                {/* <MenuItem value={"Choose State..."}>Choose Status...</MenuItem> */}
                {fillAcconutStatus()}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <FormControl fullWidth>
              <InputLabel
                id="demo-simple-select-label"
                sx={{ fontFamily: "Poppins" }}
              >
                Profile Status
              </InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={profileStatus}
                label="Profile Status"
                onChange={handleProfile}
                sx={{ fontFamily: "Poppins" }}
                required
                error={!!errors?.profileStatus}
                helperText={errors?.profileStatus}
              >
                {/* <MenuItem value={"Choose State..."}>Choose Status...</MenuItem> */}
                {fillProfileStatus()}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            <ColorButton onClick={handleSubmit} fullWidth variant="contained">
              Submit
            </ColorButton>
          </Grid>
          <Grid item xs={6}>
            <ColorButton onClick={handleReset} fullWidth variant="contained">
              Reset
            </ColorButton>
          </Grid>
        </Grid>
      </div>
    </div>
  );
}

export default AdminEdit;
